import { Box, useTheme } from "@mui/material";
import type { ReactNode } from "react";

type ScoreSidebarShellProps = {
    children: ReactNode;
};

export const ScoreSidebarShell = ({ children }: ScoreSidebarShellProps) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                backgroundColor: theme.custom.grey[100],
                border: `1px solid ${theme.custom.grey[600]}`,
                borderRadius: theme.spacing(1.5),
                boxShadow: theme.custom.shadows.grey,
                overflow: "hidden",
            }}
        >
            {children}
        </Box>
    );
};
